<div id="scroll-pages-wrapper">
    <div (scroll)="onScroll()"
         [class.ios]="isIOS"
         [class.zoomed]="applicationStateService.isZoomed"
         id="scrollablePagesContainer"
         tabindex="-1"
         data-skip-a11y
    >


        <div [ngStyle]="{'height.px': totalContainerHeight  }" id="heightContainer">

            @for (item of lowerDummyPages; track dummyIdentifier($index, item)) {
                <div [ngStyle]="{
             'height.px': dummyPageHeight}"
                     class="dummyPage">
                </div>
            }


            @for (page of currentPages; track page.id) {
                <div class="scroll-single-page-wrapper">
                    <app-scroll-page [imageHeight]="imageHeight"
                                     [imageWidth]="imageWidth"
                                     [isFirstPage]="page.index === 0"
                                     [left]="-childLeftOffset/2"
                                     [page]="page"
                                     [pagesContainer]="getContainer()"></app-scroll-page>
                </div>
            }


            @if (!isChrome) {
                @for (item of upperDummyPages; track dummyIdentifier($index, item)) {
                    <div [ngStyle]="{
             'height.px': dummyPageHeight }"
                         class="dummyPage">
                    </div>
                }
            }
        </div>
    </div>
</div>
